module.exports = __webpack_public_path__ + "static/2-b5f93aef9f5db7b22d8517f80a096747.jpg";